var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[(_vm.val == '0' || isNaN(_vm.val))?_c('h6',[_vm._v("N/A")]):_c('vue-ellipse-progress',{attrs:{"thickness":8,"color":_vm.colors,"emptyThickness":"7","progress":_vm.val ? parseInt(_vm.val.replace('<', '').replace('>', '').replace('%', '')) : 0,"half":true,"angle":-360,"size":90,"legendFormatter":function (ref) {
	var currentValue = ref.currentValue;

	return _vm.findsymbol(_vm.val);
}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }